module.exports = __webpack_public_path__ + "img/16_112.bfbf09e3.png";